import { FC } from 'react';

import NumberFormat, { NumberFormatProps } from 'react-number-format';

import { StyledInputBase } from './styled';

export type ICurrencyInput = NumberFormatProps;

const CurrencyInput: FC<ICurrencyInput> = (props) => {
  return (
    <NumberFormat
      data-testid='CurrencyInput'
      allowNegative={false}
      inputMode='numeric'
      decimalScale={2}
      customInput={StyledInputBase}
      {...props}
    />
  );
};

export default CurrencyInput;
